export const controleQuinquennalKeys = {
  all: ["controleQuinquennal"] as const,
  lists: () => [...controleQuinquennalKeys.all, "list"] as const,
  list: (params: Record<string, unknown>) =>
    [...controleQuinquennalKeys.lists(), params] as const,
  // Sous `lists()` pour que les invalidations de liste existantes l'atteignent.
  oriasRadiees: () =>
    [...controleQuinquennalKeys.lists(), "orias-radiees"] as const,
  // Sous `lists()` comme oriasRadiees : une réponse enregistrée invalide déjà
  // les listes (useSaveQuestionnaireInstanceMutation), et c'est ce qui rafraîchit
  // l'avancée du traitement — les métriques doivent être atteintes par là.
  metriques: (ids: string[]) =>
    [...controleQuinquennalKeys.lists(), "metriques", ids] as const,
  details: () => [...controleQuinquennalKeys.all, "detail"] as const,
  detail: (id: string) => [...controleQuinquennalKeys.details(), id] as const,
  axes: () => [...controleQuinquennalKeys.all, "axes"] as const,
  axe: (idCQ: string, idAxe: string) =>
    [...controleQuinquennalKeys.axes(), idCQ, idAxe] as const,
  conversationsByAxes: (idAxe: string) =>
    [...controleQuinquennalKeys.all, "conversations", idAxe] as const,
  remediationsByAxe: (idCQ: string, idAxe: string) =>
    [...controleQuinquennalKeys.all, "remediations", idCQ, idAxe] as const,
  axesWithFilesBase: (idCQ: string, idAxe: string) =>
    [...controleQuinquennalKeys.all, "axesWithFiles", idCQ, idAxe] as const,
  axeVerifications: (idCQ: string, idAxe: string) =>
    [...controleQuinquennalKeys.all, "axeVerifications", idCQ, idAxe] as const,
  axesWithFiles: (
    idCQ: string,
    idAxe: string,
    search: string = "",
    limit: number = 20
  ) =>
    [
      ...controleQuinquennalKeys.all,
      "axesWithFiles",
      idCQ,
      idAxe,
      search,
      limit,
    ] as const,
  personneAssujetties: (
    millesime: number,
    siren: string,
    search: string = "",
    limit: number = 10
  ) => [
    ...controleQuinquennalKeys.all,
    "personnesAssujetties",
    millesime,
    siren,
    search,
    limit,
  ],
  rapportPreview: (idCQ: string) =>
    [...controleQuinquennalKeys.all, "rapport-preview", idCQ] as const,
  export: (params: Record<string, unknown>) =>
    [...controleQuinquennalKeys.all, "export", params] as const,
  zipMetadata: (idCQ: string, idAxe: string) =>
    [...controleQuinquennalKeys.all, "zipMetadata", idCQ, idAxe] as const,
  analyseEstimation: (
    idCQ: string,
    params: { scope: string; idAxe?: string; subAxis?: string }
  ) =>
    [
      ...controleQuinquennalKeys.all,
      "analyseEstimation",
      idCQ,
      params,
    ] as const,
};
